// Module
var code = `<!-- blFigure — blog image with caption.
     Data shape: { src, alt, caption } -->
<figure class="{{classStr}}">
  <img src="{{src}}" alt="{{alt}}">
  <figcaption>{{caption}}</figcaption>
</figure>
`;
// Exports
module.exports = code;